import React, { FC, Fragment } from 'react';
import { MutationFunction, MutationResult } from 'react-apollo';
import { adopt, AdoptProps } from 'react-adopt';
import { ApolloError } from 'apollo-client';

import {
  CreateGroupSourceComponent,
  DeleteGroupSourceComponent,
  UpdateGroupSourceComponent,
} from 'api';

interface IRenderProp {
  mutation: MutationFunction;
  result: MutationResult;
}

export interface IMutationsRenderProps {
  createSource: IRenderProp;
  deleteSource: IRenderProp;
  updateSource: IRenderProp;
}

type IAdoptProps = AdoptProps<IMutationsRenderProps, any>;

interface IProps {
  onError: (error: ApolloError) => void;
  children: (props: IMutationsRenderProps) => React.ReactNode;
}

const Mutations: FC<IProps> = ({ children, onError }) => {
  function createSource({ render }: IAdoptProps) {
    return (
      <CreateGroupSourceComponent onError={onError}>
        {(mutation, result) => render({ mutation, result })}
      </CreateGroupSourceComponent>
    );
  }

  function deleteSource({ render }: IAdoptProps) {
    return (
      <DeleteGroupSourceComponent onError={onError}>
        {(mutation, result) => render({ mutation, result })}
      </DeleteGroupSourceComponent>
    );
  }

  function updateSource({ render }: IAdoptProps) {
    return (
      <UpdateGroupSourceComponent onError={onError}>
        {(mutation, result) => render({ mutation, result })}
      </UpdateGroupSourceComponent>
    );
  }

  const Composed = adopt<IMutationsRenderProps, {}>({
    createSource,
    deleteSource,
    updateSource,
  });

  return <Composed>{renderProps => <Fragment>{children(renderProps)}</Fragment>}</Composed>;
};

export default Mutations;
